import apiService from "./ApiService"
import { createQS } from "./Utils"

class ModeloComponenteService {
  async get(termo, idTipoComponente, pagina) {
    try {
      const qs = createQS({ termo, idTipoComponente, pagina })
      return await apiService.get('modelo-componente?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('modelo-componente/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('modelo-componente', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put('modelo-componente/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('modelo-componente/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarFilhoLimite(idModeloComponente) {
    try {
      return await apiService.get('modelo-componente/' + idModeloComponente + '/filho-limite')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async createFilhoLimite(idModeloComponente, data) {
    try {
      return await apiService.post('modelo-componente/' + idModeloComponente + '/filho-limite', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateFilhoLimite(idModeloComponente, idFilhoLimite, data) {
    try {
      return await apiService.put('modelo-componente/' + idModeloComponente + '/filho-limite/' + idFilhoLimite, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteFilhoLimite(idModeloComponente, idFilhoLimite) {
    try {
      return await apiService.delete('modelo-componente/' + idModeloComponente + '/filho-limite/' + idFilhoLimite)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const modeloComponenteService = new ModeloComponenteService()
export default modeloComponenteService
